import { API_BASE } from '../config/app';

let cachedAuthState = {
  checkedAt: 0,
  value: null,
};
let pendingAuthCheck = null;
const AUTH_CACHE_TTL_MS = 15 * 1000;
const LOGIN_MARKER_COOKIE = 'email_app_logged_in=1';

export function hasLoginMarker() {
  if (typeof document === 'undefined') return false;
  return document.cookie.split(';').some((item) => item.trim() === LOGIN_MARKER_COOKIE);
}

async function checkEndpoint(url) {
  const response = await fetch(url, {
    cache: 'no-store',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  });

  if (response.status === 401 || response.status === 403) return false;
  if (!response.ok) throw new Error('Unable to verify login status.');
  return true;
}

const AUTH_ENDPOINTS = [
  `${API_BASE}/me`,
  `${API_BASE}/user`,
];

export async function checkAuthStatus({ force = false } = {}) {
  const now = Date.now();

  // Dashboard/backend sets this shared cookie on .mailsnappy.com, so the public site can update
  // the Header button without waiting for multiple cross-domain auth probes.
  if (hasLoginMarker()) {
    cachedAuthState = { checkedAt: now, value: true };
    return true;
  }

  if (!force && cachedAuthState.value !== null && now - cachedAuthState.checkedAt < AUTH_CACHE_TTL_MS) {
    return cachedAuthState.value;
  }
  if (pendingAuthCheck) return pendingAuthCheck;

  pendingAuthCheck = AUTH_ENDPOINTS.reduce(
    (request, endpoint) => request.catch(() => checkEndpoint(endpoint)),
    Promise.reject()
  )
    .catch(() => false)
    .then((isAuthenticated) => {
      cachedAuthState = {
        checkedAt: Date.now(),
        value: isAuthenticated,
      };
      return isAuthenticated;
    })
    .finally(() => {
      pendingAuthCheck = null;
    });

  return pendingAuthCheck;
}
